import { render } from "./CreatorSelect.vue?vue&type=template&id=4d1e48d8"
import script from "./CreatorSelect.vue?vue&type=script&lang=ts"
export * from "./CreatorSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script